import { message } from 'antd';
import AppConfig from "../config/index";
import { encrypt } from "../utils/cryptoData";
import log from "../utils/prettyLog";
import { getStorage, throttle } from '../utils/utils';
const baseurl = AppConfig.REACT_APP_BASE_URL;
const weburl = AppConfig.REACT_APP_WEB_URL;
const cspValue = `default-src 'self'; script-src 'self' ${weburl}; style-src 'self' 'unsafe-inline'; img-src 'self' ${weburl}; font-src 'self'; connect-src 'self' ${baseurl}; frame-src 'self'; object-src 'none'; media-src 'self'`;
// //节流函数
const throttledError = throttle(() => {
  message.error('Network error, please check your network connection.', 7)
}, 4000);

const handleResult = throttle((text) => {
  if (text) { message.error(text, 10) }
  localStorage.clear();
  setTimeout(() => {
    log.info('location href-',weburl+'/login')
    window.location.href = weburl+'/login';
  }, 2000);
}, 1000);

const checkError = (err) => {
  switch (err) {
    case "timeout":
      handleResult("Request timed out, please try again");
      log.error("Request timed out, please try again");
      break;
    case "no_token":
      handleResult("Token not found. Please log in again.");
      log.error("Token not found. Please log in again.");
      break;
    case "token_error":
      handleResult("Token error. Please log in again.");
      log.error("Token error. Please log in again.");
      break;
    case "token_dismatch":
      handleResult("Token dismatch. Please log in again.");
      log.error("Token dismatch. Please log in again.");
      break;
    default:
      break;
  }
}
/**
 *静态的fetch请求通用方法
 * @param url
 * @param options
 * @returns {Promise<unknown>}
 */
export const StaticFetch = async (url = '', options) => {
  try {
    if (!navigator.onLine) { throttledError() }
    const aadStatus = localStorage.getItem('aadStatus') || null;
    const response = await fetch(baseurl + url, options);
    const data = await response.json();
    if (aadStatus) checkError(data?.result);

    if (response.ok) {
      return data; // 响应状态码为2xx，表示请求成功
    } else if (response.status === 404) {
      log.error('Not found ' + baseurl + url);
    } else if (response.status === 401) {
      log.error('Unauthorized access');// 响应状态码为401，表示未授权
    } else if (response.status === 421) {
      // log.error('Request timed out, please try again')
    } else if (response.status === 424) {
      console.error('not found token');
    } else {
      // 其他错误状态码的处理
      console.error(response);
    }
  } catch (error) {
    console.error('Request error.', error)
  }
}

/**  
* 发送 GET 请求  
*  
* @param {string} url - 请求的 URL  
* @param {object} option - 请求的选项对象  
* @returns {Promise} - 返回一个 Promise 对象，表示请求的结果  
*/
export function get(url) {
  const defaultOptions = {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer your-token',
      'Content-Type': 'application/json',
      'Content-Security-Policy': cspValue,
    }
  };

  const token = localStorage.getItem('qxqwqsf_d7w2c6') || null;
  return StaticFetch(url + '/' + token, defaultOptions);
}

/**
 *post请求方式
 * @param url
 * @returns {Promise<unknown>}
 */
export function post(url, params = {}, options = {}) {

  if (url === '/login') {
    const defaultOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Content-Security-Policy': cspValue,
      },
      body: JSON.stringify(params)
    };
    const newOptions = { ...defaultOptions, ...options };
    return StaticFetch(url, newOptions);
  } else {
    const token = localStorage.getItem('qxqwqsf_d7w2c6') || null;
    const clientID = getStorage('idNumber');
    const encryptParams = encrypt(params);
    const defaultOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        // Authorization: token,
      },
      body: JSON.stringify({ params: encryptParams, token: token, clientID: clientID })
    };

    const newOptions = { ...defaultOptions, ...options };
    return StaticFetch(url, newOptions);
  }
}